import { Allocation, Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function replaceAllocation(
  allocation: Identifiable<Allocation>,
  allocations: Identifiable<Allocation>[],
): Identifiable<Allocation> {
  return (
    allocations.find(
      ({ resource }) => resource.uuid === allocation.resource.uuid,
    ) || allocation
  );
}

function handleAllocateResourcesRequest(
  task: Identifiable<Task>,
  { allocations, task: t }: Boundaries["allocateResources"]["request"],
): Identifiable<Task> {
  return t.uuid === task.uuid
    ? calculateAdvancement({
        ...task,
        allocations: [
          ...task.allocations,
          ...allocations.map((allocation) => ({
            ...allocation,
            uuid: allocation.resource.uuid,
          })),
        ],
      })
    : task;
}

function handleAllocateResourcesSuccess(
  task: Identifiable<Task>,
  { allocations, task: t }: Boundaries["allocateResources"]["success"],
): Identifiable<Task> {
  if (t.uuid !== task.uuid) return task;

  const updatedAllocations = task.allocations.map((existing) =>
    replaceAllocation(existing, allocations),
  );

  const newAllocations = allocations.filter(
    (newAlloc) =>
      !task.allocations.some(
        (existing) => existing.resource.uuid === newAlloc.resource.uuid,
      ),
  );

  return calculateAdvancement({
    ...task,
    allocations: [...updatedAllocations, ...newAllocations],
  });
}

function handleAllocateResourcesFailure(
  task: Identifiable<Task>,
  { allocations, task: t }: Boundaries["allocateResources"]["failure"],
): Identifiable<Task> {
  return t.uuid === task.uuid
    ? calculateAdvancement({
        ...task,
        allocations: task.allocations.filter(
          (allocation) =>
            !allocations
              .map(({ resource }) => resource.uuid)
              .includes(allocation.resource.uuid),
        ),
      })
    : task;
}

export {
  handleAllocateResourcesRequest,
  handleAllocateResourcesSuccess,
  handleAllocateResourcesFailure,
};
